export const cardDeckThemeToTailwindClasses = (theme: any) => {
    return ["gap-4", "w-full"];
};